import fetch from 'isomorphic-fetch';
import ENV from '../environments/environment'


const orderService = {

   async createOrder(order) {
     order = JSON.stringify(order);
     const response = await fetch(`${ENV.lupita_url}orders/` , { headers: ENV.getLupitaHeaders() , method: 'POST', body: order });
     return await response.json();
   },

   async getOrderSchedule(store_id) {
     const response = await fetch( ENV.getGrabilityUrl() + 'store/delivery-price?store_id=' + store_id , { headers: ENV.getGrabilityHeaders() });
     return await response.json();
   },

   async getShippingCharges(lat,lng) {
      const response = await fetch(`${ENV.lupita_url}orders/shipping-charges/?lat=${lat}&lng=${lng}` , { headers: ENV.getLupitaHeaders()});
      return await response.json();
   }



}

export default orderService;



// WEBPACK FOOTER //
// ./src/services/order.service.js